/*

    Everywhere Product Form
    
    Everywhere's Product Form submits an array
    of Variant IDs and Quantities in the form: 
    
    items: [
      {
        id: 36110175633573,
        quantity: 2
      }, 
      ... 
    ]

    It uses a modified version of the Dawn Theme's 
    serialize form function, which looks for every
    variant to be present on the page. 

  */

class EverywhereProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.submitButton = this.querySelector('[type="submit"]');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    if (this.cartDrawer) {
      this.cartDrawer.setActiveElement(document.activeElement);
    } else if (this.cartNotification) {
      this.cartNotification.setActiveElement(document.activeElement);
    }

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');

    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const body = JSON.stringify({
      ...JSON.parse(Everywhere.serializeForm(this.form)),
      sections: this.cartDrawer
        ? this.cartDrawer.getSectionsToRender().map((section) => section.id)
        : this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (this.cartDrawer) {
          this.cartDrawer.renderContents(parsedState);
          this.cartDrawer.classList.remove('is-empty');
        }
        if (this.cartNotification) {
          this.cartNotification.renderContents(parsedState);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        const quantityInputs = document.querySelectorAll('.main-product__info-wrapper quantity-input input');
        console.log(quantityInputs);
        quantityInputs?.forEach((quantityInput) => {
          quantityInput.value = 0;
        });
      });
  }
}

customElements.define('everywhere-product-form', EverywhereProductForm);
